export default __webpack_public_path__ + "static/media/gameOver3.f7a5395c.mp3";